module.exports = __webpack_public_path__ + "img/temple.6a4c61e5.png";